import { ScheduleOrg } from '@wetags/schedule';
import { useDevToolsStore } from '@frontend/devtools';

export const useCalendarGridAccess = () => {
  const [isCalendarGridWetagEnabled, isLoadingWetag] = ScheduleOrg.useWetag('calendar-grid');
  const isDebugMode = useDevToolsStore((state) => state.options.isDebugModeOn);

  const isLoading = isLoadingWetag;
  const isEnabled = isCalendarGridWetagEnabled;

  return {
    isCalendarGridEnabled: isDebugMode || (!isLoading && isEnabled),
    isLoading,
  };
};
